import { createBrowserRouter } from "react-router";
import { Root } from "./pages/Root";
import { Home } from "./pages/Home";
import { Solutions } from "./pages/Solutions";
import { SolutionTopicPage } from "./pages/SolutionTopicPage";
import { Platform } from "./pages/Platform";
import { PlatformTopicPage } from "./pages/PlatformTopicPage";
import { Industries } from "./pages/Industries";
import { IndustryTopicPage } from "./pages/IndustryTopicPage";
import { LegalLayout } from "./pages/LegalLayout";
import { LegalIndex } from "./pages/LegalIndex";
import { LegalPolicy } from "./pages/LegalPolicy";
import { ResourcesLayout } from "./pages/ResourcesLayout";
import { Resources } from "./pages/Resources";
import { ResourceGuide } from "./pages/ResourceGuide";
import { Contact } from "./pages/Contact";
import { Features } from "./pages/Features";
import { FAQ } from "./pages/FAQ";
import { Pricing } from "./pages/Pricing";
import { ComparePlans } from "./pages/ComparePlans";
import { RequestDemo } from "./pages/RequestDemo";
import { TrialSignupPage } from "./pages/TrialSignupPage";

export const router = createBrowserRouter([
  {
    path: "/",
    Component: Root,
    children: [
      { index: true, Component: Home },
      { path: "features", Component: Features },
      { path: "faq", Component: FAQ },
      { path: "pricing", Component: Pricing },
      { path: "pricing/compare", Component: ComparePlans },
      { path: "solutions/:slug", Component: SolutionTopicPage },
      { path: "solutions", Component: Solutions },
      { path: "platform/:slug", Component: PlatformTopicPage },
      { path: "platform", Component: Platform },
      { path: "industries/:slug", Component: IndustryTopicPage },
      { path: "industries", Component: Industries },
      { path: "contact", Component: Contact },
      { path: "request-demo", Component: RequestDemo },
      { path: "get-started", Component: TrialSignupPage },
      {
        path: "legal",
        Component: LegalLayout,
        children: [
          { index: true, Component: LegalIndex },
          { path: ":slug", Component: LegalPolicy },
        ],
      },
      {
        path: "resources",
        Component: ResourcesLayout,
        children: [
          { index: true, Component: Resources },
          { path: ":slug", Component: ResourceGuide },
        ],
      },
    ],
  },
]);
